import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { useMemo, useState } from "react";
import { ListarModulosController } from "../../../../../Controllers/Geral/Documentos/DocumentosController";
import {
    HistoricoClienteInterface,
    IFiltroHistorico,
} from "../../../../../Interfaces/Geral/Historicos/HistoricoInterface";
import { IUserBase } from "../../../../../Interfaces/Users/UsersInterface";
import UnForm from "../../../../Form";
import { Spinner } from "../../../../Loding/SpinnerPadrao";

interface IFiltroHistoricoProps {
    handleSubmit: (filter: IFiltroHistorico) => void;
    historico: Array<HistoricoClienteInterface>;
    loadingFilter: boolean;
}

export default function FiltroHistorico(props: IFiltroHistoricoProps) {
    const [idTipoCaso, setIdTipoCaso] = useState(0);

    const lstUsuariosDoHistorico = useMemo(
        () =>
            props.historico.reduce((listaUsuarios, historico) => {
                if (
                    !listaUsuarios.some(
                        (u) => u.ID_USUARIO === historico.ID_USUARIO
                    )
                ) {
                    listaUsuarios.push({
                        ID_USUARIO: historico.ID_USUARIO,
                        DS_NOME: historico.DS_USUARIO,
                    });
                }
                return listaUsuarios;
            }, [] as Array<IUserBase>),
        [props.historico]
    );

    return (
        <div>
            <UnForm handleSubmit={props.handleSubmit} className="mb-4">
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Data Início</label>
                            <UnForm.Input
                                type="date"
                                name="DT_INICIO"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Data Fim</label>
                            <UnForm.Input
                                type="date"
                                name="DT_FIM"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Usuário Responsável</label>
                            <UnForm.Select
                                name="ID_USUARIO"
                                className="form-control"
                                registerOptions={{
                                    valueAsNumber: true,
                                }}
                            >
                                <option></option>
                                {lstUsuariosDoHistorico.map((value) => (
                                    <option
                                        key={value.ID_USUARIO}
                                        value={value.ID_USUARIO}
                                    >
                                        {value.DS_NOME}
                                    </option>
                                ))}
                            </UnForm.Select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <UnForm.Select
                                color="primary"
                                name="FL_SISTEMA_USUARIO"
                                className="form-control"
                                label="Histórico Gerado por:"
                                defaultValue={"cliente"}
                            >
                                <option defaultValue={undefined}></option>
                                <option value={"cliente"}>Usuário</option>
                                <option value={"sistema"}>Sistema</option>
                            </UnForm.Select>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <UnForm.LazySelect
                                controller={ListarModulosController}
                                getDS={(ca) => ca.DS_MODULO}
                                getKeyValue={(ca) => ca.ID_MODULO}
                                className="form-control"
                                name="ID_TIPO_CASO"
                                label="Tipo Caso"
                                value={idTipoCaso}
                                onChange={(e) =>
                                    setIdTipoCaso(Number(e.target.value))
                                }
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                    </div>
                    <UnForm.SubmitButton
                        color="success"
                        type="submit"
                        wrapperClassName="col-12"
                        className="py-3 w-100"
                        icon={faFilter}
                        disabled={props.loadingFilter}
                        outline
                    >
                        {props.loadingFilter && <Spinner size="sm" />} Filtrar
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </div>
    );
}
